import { useFormik } from 'formik';
import * as Yup from 'yup';
import { IUser, IUserAddProps } from '../../../../../interfaces/user';

export const getInitialValues = (
  user: IUser | null,
) => ({
  firstName: user?.firstName || '',
  lastName: user?.lastName || '',
  email: user?.email || '',
  role: user?.role || 'USER',
  platformFee: user?.platformFee || 1,
  companyName: user?.companyName || '',
  companyAddress: user?.companyAddress || '',
  csbClientId: user?.csbClientId || ''
});

export const useFormikUserEdit = (
  id: number | undefined | string,
  user: IUser | null,
  edit: any,
  add: any,
  setUserOpen: (user: boolean) => void,
  page: number | undefined
) => {
  const nameRegex = /^(?![_\s.\-'])(?!.*[_\s.\-']{2})[a-zA-Z\s.\-']+(?<![_\s.\-'])$/;

  return useFormik({
    enableReinitialize: true,
    initialValues: getInitialValues(user),
    validationSchema: Yup.object().shape({
      email: Yup.string()
        .required('Enter Email')
        .email('Invalid Email')
        .nullable(),
      lastName: Yup.string()
        .matches(
          nameRegex,
          'Invalid surname format'
        )
        .required('Enter surname'),
      firstName: Yup.string()
      .matches(
        nameRegex,
        'Invalid name format'
      )
      .required('Enter name'),
      companyName: Yup.string()
        .required('Enter company name')
        .min(1, 'Company name must be at least 1 character')
        .max(200, 'Company name must not exceed 200 characters'),
      companyAddress: Yup.string()
        .required('Enter company address')
        .min(1, 'Company address must be at least 1 character')
        .max(200, 'Company address must not exceed 200 characters'),
      csbClientId: Yup.string().when(['role', '$id'], {
        is: (role: string, id: string | number | undefined) =>
          role === 'USER' && !id,
        then: schema => schema.required('Enter csb Client Id'),
        otherwise: schema => schema
      })
    }),


    onSubmit: values => {
      if (id) {
        edit({
          id,
          data: {
            firstName: values.firstName,
            lastName: values.lastName,
            platformFee: Number(values.platformFee),
            email: values.email,
            companyName: values.companyName,
            companyAddress: values.companyAddress,
            csbClientId: values.csbClientId,
          },
          page
        });
        setUserOpen(false)
      } else {
        const addData: IUserAddProps = {
          ...values,
        };
        add(addData);
      }
    },
  });
};
